module.exports = __webpack_public_path__ + "img/image48.bcf95566.png";